module.exports = __webpack_public_path__ + "static/media/compe.e446edff.jpg";